import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Discount {
  id: string;
  name: string;
  link: string;
  description: string;
  category: string[];
  region: string;
  discountType: string[];
  date: string;
  popularity: boolean;
  imageId: string;
  about: string;
  observations: string;
  expiration_date: string;
  voucher: string;
  position: string;
  bannerImageId: string;
}

const discountsSlice = createSlice({
  name: "discounts",
  initialState: [] as Discount[],
  reducers: {
    setDiscounts: (_, action: PayloadAction<any>) => {
      return action.payload;
    },
  },
});
export const { setDiscounts } = discountsSlice.actions;

export default discountsSlice.reducer;
